import SiafLiteApiRepository from "../../external/siafLiteApi";
import encrypt from "../../utils/encrypt";

class MeuUsuarioService {
  constructor() {
    this.urlBase = "/painel-controle/meu-usuario";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  get() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  validarToken() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-token`
    ).get();
  }

  trocarToken(empresaId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/trocar-token/${empresaId}`
    ).get();
  }

  validarPermissao(emailSenha, permission) {
    const basicAuth = encrypt(emailSenha);
    const body = { basicAuth, permission };
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/login-permissao`
    ).post(body);
  }
}

export default MeuUsuarioService;
